module.exports = __webpack_public_path__ + "static/media/5_3.1e45e4c2.jpg";